import { GlCollapsibleListbox } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { debounce } from 'lodash-es';
import { createAlert } from '../../../alert.js?vue3';
import { s__ } from '~/locale';
import axios from '../../../lib/utils/axios_utils.js?vue3';
import { DEFAULT_DEBOUNCE_AND_THROTTLE_MS } from '~/lib/utils/constants';
export default {
    name: 'RepoDropdown',
    components: {
        GlCollapsibleListbox
    },
    inject: [
        'targetProjectsPath'
    ],
    props: {
        paramsName: {
            type: String,
            required: true
        },
        selectedProject: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'select-project'
    ],
    data () {
        return {
            loadingProjects: false,
            allProjects: []
        };
    },
    computed: {
        inputName () {
            return `${this.paramsName}_project_id`;
        }
    },
    mounted () {
        this.debouncedSearch = debounce(this.fetchForks, DEFAULT_DEBOUNCE_AND_THROTTLE_MS);
        this.fetchForks();
    },
    beforeDestroy () {
        if (this.debouncedSearch) {
            this.debouncedSearch.cancel();
        }
    },
    methods: {
        async fetchForks (search = '') {
            if (this.disabled) return;
            this.loadingProjects = true;
            try {
                const { data } = await axios.get(this.targetProjectsPath, {
                    params: {
                        search
                    }
                });
                this.allProjects = data.map((project)=>({
                        ...project,
                        value: project.id,
                        text: project.full_name
                    }));
            } catch (error) {
                createAlert({
                    message: s__('CompareRevisions|An error occurred while retrieving target projects.'),
                    captureError: true,
                    error
                });
            } finally{
                this.loadingProjects = false;
            }
        },
        emitTargetProject (projectId) {
            const project = this.allProjects.find(({ value })=>value === projectId);
            if (project) {
                this.$emit('select-project', {
                    direction: this.paramsName,
                    project
                });
            }
        },
        onSearch (searchTerm) {
            this.debouncedSearch(searchTerm);
        }
    }
};
